import React from 'react';
import PropTypes from 'prop-types';

export default function ChevronLeft(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
  );
}

ChevronLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

ChevronLeft.defaultProps = {
  color: '#202020',
  width: 20,
};